import React, { FC, useEffect } from 'react';
import Ellipse1757 from '../../../Icons/Ellipse1757.js';
import Ellipse1758 from '../../../Icons/Ellipse1758.js';
import Ellipse1759 from '../../../Icons/Ellipse1759.js';
import { ProgressStateContainer, LoadingContent, LoadingDots, LoadingDot, ProgressTitle } from './index.styles';
import { setViewMeta } from '@ecs-uk/web-common-mobile-view-helpers';

interface LoadingStageProps {
  loadingMessage: string;
  isWebview?: boolean;
}

const LoadingStage: FC<LoadingStageProps> = ({ loadingMessage, isWebview = false }) => {
  useEffect(() => {
    setViewMeta({ viewTitle: 'Confirm' });
  }, []);

  return (
    <ProgressStateContainer $isWebview={isWebview}>
      <LoadingContent>
        <LoadingDots aria-hidden="true">
          <LoadingDot $delay="0s">
            <Ellipse1758 />
          </LoadingDot>
          <LoadingDot $delay="0.15s">
            <Ellipse1759 />
          </LoadingDot>
          <LoadingDot $delay="0.3s">
            <Ellipse1757 />
          </LoadingDot>
        </LoadingDots>
        <ProgressTitle>{loadingMessage}</ProgressTitle>
      </LoadingContent>
    </ProgressStateContainer>
  );
};

export default LoadingStage;
